import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconPaymentMethodsBancontact, LazyIconPaymentMethodsIdeal, LazyIconPaymentMethodsMastercard, LazyIconPaymentMethodsVisa, LazyIconAccount, LazyIconArrowCurve, LazyIconArrowLong, LazyIconArrowShort, LazyIconCalendar, LazyIconCheck, LazyIconClose, LazyIconCssSelect, LazyIconDilleKamille, LazyIconEmail, LazyIconError, LazyIconHeart, LazyIconInfo, LazyIconLogout, LazyIconMarker, LazyIconPaperPlane, LazyIconPaymentMethodsMaestro, LazyIconPhone, LazyIconShoppingbag, LazyIconSuccess, LazyIconThee, LazyIconDeprecatedGooglePlus, LazyIconDeprecatedKlarna1, LazyIconDeprecatedKlarnaKonto, LazyIconDeprecatedTnt, LazyIconDeprecatedTrustedShopsV1, LazyIconDeprecatedTwitter, LazyIconDeprecatedVvvGiftcardV1, LazyIconArrow, LazyIconBankenAbnAmro, LazyIconBankenAsn, LazyIconBankenBelfius, LazyIconBankenFortis, LazyIconBankenIng, LazyIconBankenKbc, LazyIconBankenKnab, LazyIconBankenRabobank, LazyIconBankenSns, LazyIconBankenTriodos, LazyIconBankenVanlanschot, LazyIconChat, LazyIconCssCheckboxChecked, LazyIconCssInputValid, LazyIconCssNoImage, LazyIconCssStepChecked, LazyIconCustomer, LazyIconDeliveryMethodsAnpost, LazyIconDeliveryMethodsAtpost, LazyIconDeliveryMethodsB2ce, LazyIconDeliveryMethodsBpost, LazyIconDeliveryMethodsColissimo, LazyIconDeliveryMethodsDeutschePost, LazyIconDeliveryMethodsDhl, LazyIconDeliveryMethodsDpd, LazyIconDeliveryMethodsFedexExpress, LazyIconDeliveryMethodsFietskoeriers, LazyIconDeliveryMethodsGls, LazyIconDeliveryMethodsGlsdk, LazyIconDeliveryMethodsKiala, LazyIconDeliveryMethodsPostNl, LazyIconDeliveryMethodsSkynet, LazyIconDeliveryMethodsTaxydromikisa, LazyIconDeliveryMethodsTourline, LazyIconDeliveryMethodsUps, LazyIconDelivery, LazyIconEnlarge, LazyIconEyeClosed, LazyIconEyeOpen, LazyIconFilter, LazyIconFlagsAu, LazyIconFlagsBe, LazyIconFlagsDe, LazyIconFlagsEs, LazyIconFlagsFr, LazyIconFlagsGb, LazyIconFlagsGlobal, LazyIconFlagsIt, LazyIconFlagsLu, LazyIconFlagsNl, LazyIconGrid, LazyIconHeartEmpty, LazyIconHeartFilled, LazyIconLabelsBecommerce, LazyIconLabelsCwb, LazyIconLabelsDrugProvider, LazyIconLabelsEcommerceEuropeTrustmark, LazyIconLabelsEuOrganic, LazyIconLabelsHaendlerbundMitglied, LazyIconLabelsKiyoh, LazyIconLabelsThuiswinkelWaarborg, LazyIconLabelsThuiswinkelWaarborgLabelBottom, LazyIconLabelsThuiswinkelWaarborgLabelRight, LazyIconLabelsTrustedShops, LazyIconLabelsTrustpilot, LazyIconLabelsWebshopKeurmerkLiggend, LazyIconLabelsWebshopKeurmerkStaand, LazyIconList, LazyIconLoader, LazyIconLocation, LazyIconLock, LazyIconMenu, LazyIconMin, LazyIconNoLocation, LazyIconPaymentMethodsAcceptgiro, LazyIconPaymentMethodsAfterpayRiverty, LazyIconPaymentMethodsAfterpay, LazyIconPaymentMethodsAmericanExpress, LazyIconPaymentMethodsApplePay, LazyIconPaymentMethodsBancontact1, LazyIconPaymentMethodsBancontactMistercash, LazyIconPaymentMethodsBankoverschrijving, LazyIconPaymentMethodsBillink, LazyIconPaymentMethodsCarteBancaire, LazyIconPaymentMethodsCarteBleue, LazyIconPaymentMethodsCirrus, LazyIconPaymentMethodsClickAndBuy, LazyIconPaymentMethodsCreditcard, LazyIconPaymentMethodsDankort, LazyIconPaymentMethodsDeCadeaukaart, LazyIconPaymentMethodsDiscover, LazyIconPaymentMethodsEps, LazyIconPaymentMethodsFashionCheque, LazyIconPaymentMethodsFlyingBlue, LazyIconPaymentMethodsGiropay, LazyIconPaymentMethodsGooglePay, LazyIconPaymentMethodsIban, LazyIconPaymentMethodsIngHomepay, LazyIconPaymentMethodsKlarnaSmall, LazyIconPaymentMethodsKlarna, LazyIconPaymentMethodsMastercard1, LazyIconPaymentMethodsOverboeking, LazyIconPaymentMethodsPayByBank, LazyIconPaymentMethodsPayPerMailEur, LazyIconPaymentMethodsPayconiq, LazyIconPaymentMethodsPaypal, LazyIconPaymentMethodsPaypalIcon, LazyIconPaymentMethodsPaypalNoIcon, LazyIconPaymentMethodsPin, LazyIconPaymentMethodsRiverty, LazyIconPaymentMethodsSign2pay, LazyIconPaymentMethodsSofortBanking, LazyIconPaymentMethodsSofortUberweisung, LazyIconPaymentMethodsSofort, LazyIconPaymentMethodsVPay, LazyIconPaymentMethodsVvvGiftcard, LazyIconPaymentMethodsWebshopGiftcard, LazyIconPencil, LazyIconPlus, LazyIconPointer, LazyIconPrinter, LazyIconPrismicEdit, LazyIconRefresh, LazyIconSearch, LazyIconSecure, LazyIconShoppingcart, LazyIconSocialMediaEmail, LazyIconSocialMediaFacebook, LazyIconSocialMediaInstagram, LazyIconSocialMediaLinkedin, LazyIconSocialMediaPinterest, LazyIconSocialMediaTiktok, LazyIconSocialMediaVimeo, LazyIconSocialMediaWhatsapp, LazyIconSocialMediaX, LazyIconSocialMediaYoutube, LazyIconSort, LazyIconSpike, LazyIconStarHollow, LazyIconStar, LazyIconStars, LazyIconThumb, LazyIconTrash, LazyIconWarning, LazyIconWhatsapp, LazyIconZoom } from '#components'
const lazyGlobalComponents = [
  ["IconPaymentMethodsBancontact", LazyIconPaymentMethodsBancontact],
["IconPaymentMethodsIdeal", LazyIconPaymentMethodsIdeal],
["IconPaymentMethodsMastercard", LazyIconPaymentMethodsMastercard],
["IconPaymentMethodsVisa", LazyIconPaymentMethodsVisa],
["IconAccount", LazyIconAccount],
["IconArrowCurve", LazyIconArrowCurve],
["IconArrowLong", LazyIconArrowLong],
["IconArrowShort", LazyIconArrowShort],
["IconCalendar", LazyIconCalendar],
["IconCheck", LazyIconCheck],
["IconClose", LazyIconClose],
["IconCssSelect", LazyIconCssSelect],
["IconDilleKamille", LazyIconDilleKamille],
["IconEmail", LazyIconEmail],
["IconError", LazyIconError],
["IconHeart", LazyIconHeart],
["IconInfo", LazyIconInfo],
["IconLogout", LazyIconLogout],
["IconMarker", LazyIconMarker],
["IconPaperPlane", LazyIconPaperPlane],
["IconPaymentMethodsMaestro", LazyIconPaymentMethodsMaestro],
["IconPhone", LazyIconPhone],
["IconShoppingbag", LazyIconShoppingbag],
["IconSuccess", LazyIconSuccess],
["IconThee", LazyIconThee],
["IconDeprecatedGooglePlus", LazyIconDeprecatedGooglePlus],
["IconDeprecatedKlarna1", LazyIconDeprecatedKlarna1],
["IconDeprecatedKlarnaKonto", LazyIconDeprecatedKlarnaKonto],
["IconDeprecatedTnt", LazyIconDeprecatedTnt],
["IconDeprecatedTrustedShopsV1", LazyIconDeprecatedTrustedShopsV1],
["IconDeprecatedTwitter", LazyIconDeprecatedTwitter],
["IconDeprecatedVvvGiftcardV1", LazyIconDeprecatedVvvGiftcardV1],
["IconArrow", LazyIconArrow],
["IconBankenAbnAmro", LazyIconBankenAbnAmro],
["IconBankenAsn", LazyIconBankenAsn],
["IconBankenBelfius", LazyIconBankenBelfius],
["IconBankenFortis", LazyIconBankenFortis],
["IconBankenIng", LazyIconBankenIng],
["IconBankenKbc", LazyIconBankenKbc],
["IconBankenKnab", LazyIconBankenKnab],
["IconBankenRabobank", LazyIconBankenRabobank],
["IconBankenSns", LazyIconBankenSns],
["IconBankenTriodos", LazyIconBankenTriodos],
["IconBankenVanlanschot", LazyIconBankenVanlanschot],
["IconChat", LazyIconChat],
["IconCssCheckboxChecked", LazyIconCssCheckboxChecked],
["IconCssInputValid", LazyIconCssInputValid],
["IconCssNoImage", LazyIconCssNoImage],
["IconCssStepChecked", LazyIconCssStepChecked],
["IconCustomer", LazyIconCustomer],
["IconDeliveryMethodsAnpost", LazyIconDeliveryMethodsAnpost],
["IconDeliveryMethodsAtpost", LazyIconDeliveryMethodsAtpost],
["IconDeliveryMethodsB2ce", LazyIconDeliveryMethodsB2ce],
["IconDeliveryMethodsBpost", LazyIconDeliveryMethodsBpost],
["IconDeliveryMethodsColissimo", LazyIconDeliveryMethodsColissimo],
["IconDeliveryMethodsDeutschePost", LazyIconDeliveryMethodsDeutschePost],
["IconDeliveryMethodsDhl", LazyIconDeliveryMethodsDhl],
["IconDeliveryMethodsDpd", LazyIconDeliveryMethodsDpd],
["IconDeliveryMethodsFedexExpress", LazyIconDeliveryMethodsFedexExpress],
["IconDeliveryMethodsFietskoeriers", LazyIconDeliveryMethodsFietskoeriers],
["IconDeliveryMethodsGls", LazyIconDeliveryMethodsGls],
["IconDeliveryMethodsGlsdk", LazyIconDeliveryMethodsGlsdk],
["IconDeliveryMethodsKiala", LazyIconDeliveryMethodsKiala],
["IconDeliveryMethodsPostNl", LazyIconDeliveryMethodsPostNl],
["IconDeliveryMethodsSkynet", LazyIconDeliveryMethodsSkynet],
["IconDeliveryMethodsTaxydromikisa", LazyIconDeliveryMethodsTaxydromikisa],
["IconDeliveryMethodsTourline", LazyIconDeliveryMethodsTourline],
["IconDeliveryMethodsUps", LazyIconDeliveryMethodsUps],
["IconDelivery", LazyIconDelivery],
["IconEnlarge", LazyIconEnlarge],
["IconEyeClosed", LazyIconEyeClosed],
["IconEyeOpen", LazyIconEyeOpen],
["IconFilter", LazyIconFilter],
["IconFlagsAu", LazyIconFlagsAu],
["IconFlagsBe", LazyIconFlagsBe],
["IconFlagsDe", LazyIconFlagsDe],
["IconFlagsEs", LazyIconFlagsEs],
["IconFlagsFr", LazyIconFlagsFr],
["IconFlagsGb", LazyIconFlagsGb],
["IconFlagsGlobal", LazyIconFlagsGlobal],
["IconFlagsIt", LazyIconFlagsIt],
["IconFlagsLu", LazyIconFlagsLu],
["IconFlagsNl", LazyIconFlagsNl],
["IconGrid", LazyIconGrid],
["IconHeartEmpty", LazyIconHeartEmpty],
["IconHeartFilled", LazyIconHeartFilled],
["IconLabelsBecommerce", LazyIconLabelsBecommerce],
["IconLabelsCwb", LazyIconLabelsCwb],
["IconLabelsDrugProvider", LazyIconLabelsDrugProvider],
["IconLabelsEcommerceEuropeTrustmark", LazyIconLabelsEcommerceEuropeTrustmark],
["IconLabelsEuOrganic", LazyIconLabelsEuOrganic],
["IconLabelsHaendlerbundMitglied", LazyIconLabelsHaendlerbundMitglied],
["IconLabelsKiyoh", LazyIconLabelsKiyoh],
["IconLabelsThuiswinkelWaarborg", LazyIconLabelsThuiswinkelWaarborg],
["IconLabelsThuiswinkelWaarborgLabelBottom", LazyIconLabelsThuiswinkelWaarborgLabelBottom],
["IconLabelsThuiswinkelWaarborgLabelRight", LazyIconLabelsThuiswinkelWaarborgLabelRight],
["IconLabelsTrustedShops", LazyIconLabelsTrustedShops],
["IconLabelsTrustpilot", LazyIconLabelsTrustpilot],
["IconLabelsWebshopKeurmerkLiggend", LazyIconLabelsWebshopKeurmerkLiggend],
["IconLabelsWebshopKeurmerkStaand", LazyIconLabelsWebshopKeurmerkStaand],
["IconList", LazyIconList],
["IconLoader", LazyIconLoader],
["IconLocation", LazyIconLocation],
["IconLock", LazyIconLock],
["IconMenu", LazyIconMenu],
["IconMin", LazyIconMin],
["IconNoLocation", LazyIconNoLocation],
["IconPaymentMethodsAcceptgiro", LazyIconPaymentMethodsAcceptgiro],
["IconPaymentMethodsAfterpayRiverty", LazyIconPaymentMethodsAfterpayRiverty],
["IconPaymentMethodsAfterpay", LazyIconPaymentMethodsAfterpay],
["IconPaymentMethodsAmericanExpress", LazyIconPaymentMethodsAmericanExpress],
["IconPaymentMethodsApplePay", LazyIconPaymentMethodsApplePay],
["IconPaymentMethodsBancontact1", LazyIconPaymentMethodsBancontact1],
["IconPaymentMethodsBancontactMistercash", LazyIconPaymentMethodsBancontactMistercash],
["IconPaymentMethodsBankoverschrijving", LazyIconPaymentMethodsBankoverschrijving],
["IconPaymentMethodsBillink", LazyIconPaymentMethodsBillink],
["IconPaymentMethodsCarteBancaire", LazyIconPaymentMethodsCarteBancaire],
["IconPaymentMethodsCarteBleue", LazyIconPaymentMethodsCarteBleue],
["IconPaymentMethodsCirrus", LazyIconPaymentMethodsCirrus],
["IconPaymentMethodsClickAndBuy", LazyIconPaymentMethodsClickAndBuy],
["IconPaymentMethodsCreditcard", LazyIconPaymentMethodsCreditcard],
["IconPaymentMethodsDankort", LazyIconPaymentMethodsDankort],
["IconPaymentMethodsDeCadeaukaart", LazyIconPaymentMethodsDeCadeaukaart],
["IconPaymentMethodsDiscover", LazyIconPaymentMethodsDiscover],
["IconPaymentMethodsEps", LazyIconPaymentMethodsEps],
["IconPaymentMethodsFashionCheque", LazyIconPaymentMethodsFashionCheque],
["IconPaymentMethodsFlyingBlue", LazyIconPaymentMethodsFlyingBlue],
["IconPaymentMethodsGiropay", LazyIconPaymentMethodsGiropay],
["IconPaymentMethodsGooglePay", LazyIconPaymentMethodsGooglePay],
["IconPaymentMethodsIban", LazyIconPaymentMethodsIban],
["IconPaymentMethodsIngHomepay", LazyIconPaymentMethodsIngHomepay],
["IconPaymentMethodsKlarnaSmall", LazyIconPaymentMethodsKlarnaSmall],
["IconPaymentMethodsKlarna", LazyIconPaymentMethodsKlarna],
["IconPaymentMethodsMastercard1", LazyIconPaymentMethodsMastercard1],
["IconPaymentMethodsOverboeking", LazyIconPaymentMethodsOverboeking],
["IconPaymentMethodsPayByBank", LazyIconPaymentMethodsPayByBank],
["IconPaymentMethodsPayPerMailEur", LazyIconPaymentMethodsPayPerMailEur],
["IconPaymentMethodsPayconiq", LazyIconPaymentMethodsPayconiq],
["IconPaymentMethodsPaypal", LazyIconPaymentMethodsPaypal],
["IconPaymentMethodsPaypalIcon", LazyIconPaymentMethodsPaypalIcon],
["IconPaymentMethodsPaypalNoIcon", LazyIconPaymentMethodsPaypalNoIcon],
["IconPaymentMethodsPin", LazyIconPaymentMethodsPin],
["IconPaymentMethodsRiverty", LazyIconPaymentMethodsRiverty],
["IconPaymentMethodsSign2pay", LazyIconPaymentMethodsSign2pay],
["IconPaymentMethodsSofortBanking", LazyIconPaymentMethodsSofortBanking],
["IconPaymentMethodsSofortUberweisung", LazyIconPaymentMethodsSofortUberweisung],
["IconPaymentMethodsSofort", LazyIconPaymentMethodsSofort],
["IconPaymentMethodsVPay", LazyIconPaymentMethodsVPay],
["IconPaymentMethodsVvvGiftcard", LazyIconPaymentMethodsVvvGiftcard],
["IconPaymentMethodsWebshopGiftcard", LazyIconPaymentMethodsWebshopGiftcard],
["IconPencil", LazyIconPencil],
["IconPlus", LazyIconPlus],
["IconPointer", LazyIconPointer],
["IconPrinter", LazyIconPrinter],
["IconPrismicEdit", LazyIconPrismicEdit],
["IconRefresh", LazyIconRefresh],
["IconSearch", LazyIconSearch],
["IconSecure", LazyIconSecure],
["IconShoppingcart", LazyIconShoppingcart],
["IconSocialMediaEmail", LazyIconSocialMediaEmail],
["IconSocialMediaFacebook", LazyIconSocialMediaFacebook],
["IconSocialMediaInstagram", LazyIconSocialMediaInstagram],
["IconSocialMediaLinkedin", LazyIconSocialMediaLinkedin],
["IconSocialMediaPinterest", LazyIconSocialMediaPinterest],
["IconSocialMediaTiktok", LazyIconSocialMediaTiktok],
["IconSocialMediaVimeo", LazyIconSocialMediaVimeo],
["IconSocialMediaWhatsapp", LazyIconSocialMediaWhatsapp],
["IconSocialMediaX", LazyIconSocialMediaX],
["IconSocialMediaYoutube", LazyIconSocialMediaYoutube],
["IconSort", LazyIconSort],
["IconSpike", LazyIconSpike],
["IconStarHollow", LazyIconStarHollow],
["IconStar", LazyIconStar],
["IconStars", LazyIconStars],
["IconThumb", LazyIconThumb],
["IconTrash", LazyIconTrash],
["IconWarning", LazyIconWarning],
["IconWhatsapp", LazyIconWhatsapp],
["IconZoom", LazyIconZoom],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
